import React, { useEffect } from 'react';

import { getCoreConfig } from '../config/config';
import { EventProperties } from './Tracking';

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    analytics: any;
  }
}

export interface Props {
  children: React.ReactNode;
}

export const segmentReset = (): void => {
  window.analytics.reset();
};

export async function trackEvent(eventName: string, properties?: EventProperties): Promise<void> {
  window.analytics?.track(eventName, properties);
}

export async function trackClick(properties: Record<string, unknown>): Promise<void> {
  window.analytics?.track('click', properties);
}

const Segment: React.FC<Props> = (props: Props) => {
  const { children } = props;

  useEffect(() => window.analytics?.load?.(getCoreConfig().segmentApiKey), []);

  return <>{children}</>;
};

export default Segment;
